<template>
  <app-card
    :border-color="cardBorderColor"
    body-class="space-y-3"
  >
    <div class="flex justify-between items-start">
      <user-badge
        :user-img="user?.picture"
        :user-name="userName"
        :description="user?.email"
      />
      <template v-if="nextStatus">
        <div class="flex items-center gap-2">
          <app-badge
            size="sm"
            class="opacity-50 line-through"
          >
            {{ userStatus }}
          </app-badge>
          <app-icon
            name="chevron-right-double"
            size="sm"
          />
          <user-status-badge :status="nextStatus" />
        </div>
      </template>
      <template v-else>
        <user-status-badge :status="userStatus" />
      </template>
    </div>
    <div class="flex items-center gap-1 ml-13">
      <app-badge
        v-for="role in roles"
        :key="role.id"
      >
        {{ role.name }}
      </app-badge>
    </div>
  </app-card>
</template>

<script setup>
import { computed } from 'vue';
import { getUserName, getUserStatus } from '@/utils/users';
import UserBadge from '@/components/sidebar/UserBadge.vue';
import UserStatusBadge from '@/components/users/UserStatusBadge.vue';
import AppBadge from '@/components/ui/AppBadge.vue';
import { UserStatus } from '@/constants/users';

const props = defineProps({
  user: {
    type: Object,
    default: () => ({}),
  },
  roles: {
    type: Array,
    default: () => [],
  },
  cardBorderColor: {
    type: String,
    default: 'neutral',
  },
  nextStatus: {
    type: String,
    validator: (value) => Object.values(UserStatus).includes(value),
    required: false,
  },
});

const userName = computed(() => getUserName(props.user));
const userStatus = computed(() => getUserStatus(props.user));
</script>
